import { render, staticRenderFns } from "./Home.view.vue?vue&type=template&id=3c6561e0&scoped=true&lang=pug&"
import script from "./Home.view.vue?vue&type=script&lang=js&"
export * from "./Home.view.vue?vue&type=script&lang=js&"
import style0 from "./Home.view.vue?vue&type=style&index=0&id=3c6561e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6561e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
installComponents(component, {VCard,VFlex})
